import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"outlined":""}},[_c(VList,{staticClass:"pa-0",attrs:{"dense":"","flat":""}},[_c(VListItem,[_c(VListItemAvatar,[_c(VIcon,{attrs:{"color":_vm.style.color}},[_vm._v(_vm._s(_vm.$vuetify.icons.values[_vm.style.icon]))])],1),_c(VListItemContent,[_c(VListItemTitle,[_vm._v(_vm._s(_vm.item.count)+" ")]),_c(VListItemSubtitle,[_vm._v(" "+_vm._s(_vm.$t(`dashboards.${_vm.cleanedLabel}`)))])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }